module.exports = {"deleteButton":"Delete guardian","addGuardianButton":"Enter guardian +","meta":"My guardians"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/guardians.json
// module id = xsDJ
// module chunks = 1